
        import * as module0 from '././components/Image/index.js';import * as module1 from '././components/MultiSelect/index.js'
        const modules = [{name: 'components--Image--index.js', module: module0, filename: './components/Image/index.js'},{name: 'components--MultiSelect--index.js', module: module1, filename: './components/MultiSelect/index.js'}]
        export default modules;
      